module.exports = __webpack_public_path__ + "images/step-checkbox-inactive.svg";